export type CalculationStatusKey = 'scheduled' | 'inProgress' | 'complete' | 'error' | 'retryFailed'

export interface CalculationStatusInfo {
  key: CalculationStatusKey
  color: string
}

// Backend status values stay unchanged (D2208-491); only the partner-facing wording is mapped in the UI.
// HARVESTER = not calculated yet; SCHEDULED = last calculation succeeded (queued for the daily re-run).
const STATUS_INFO: Record<string, CalculationStatusInfo> = {
  HARVESTER: { key: 'scheduled', color: 'grey' },
  SCHEDULED_PROCESSING: { key: 'inProgress', color: 'blue' },
  PROCESSING: { key: 'inProgress', color: 'blue' },
  SCHEDULED: { key: 'complete', color: 'green' },
  ERRORED: { key: 'error', color: 'red' },
  GP_NOT_PROCESSED: { key: 'error', color: 'red' },
  QUARANTINE: { key: 'retryFailed', color: 'red' }
}

const FAILED_STATUSES = ['ERRORED', 'GP_NOT_PROCESSED', 'QUARANTINE']

export function getCalculationStatusInfo(status?: string | null): CalculationStatusInfo | undefined {
  if (!status) return undefined
  return STATUS_INFO[status.toUpperCase()]
}

export function isCalculationFailed(status?: string | null): boolean {
  return !!status && FAILED_STATUSES.includes(status.toUpperCase())
}

export interface CalculationStatusDisplay {
  label: string
  color: string
  tooltip?: string
}

// Unmapped statuses fall back to the raw backend value so new codes stay visible instead of disappearing.
export function getCalculationStatusDisplay(status: string, t: (key: string) => string): CalculationStatusDisplay {
  const info = getCalculationStatusInfo(status)
  if (!info) return { label: status.toUpperCase(), color: 'grey' }
  return {
    label: t(`domain.statuses.calculationStatus.${info.key}.label`),
    color: info.color,
    tooltip: t(`domain.statuses.calculationStatus.${info.key}.tooltip`)
  }
}
